import React from "react";
import "./Skeleton.scss";

interface SkeletonProps {
  variant?: "text" | "card";
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton = ({
  variant = "text",
  width,
  height,
  borderRadius,
  className = "",
  style = {},
}: SkeletonProps) => {
  const variantClass = variant === "card" ? "skeletonCard" : "skeletonText";

  return (
    <span
      className={`skeleton ${variantClass} ${className}`}
      style={{ width, height, borderRadius, ...style }}
    />
  );
};

export default Skeleton;
